import { render, staticRenderFns } from "./LoanCardex.vue?vue&type=template&id=58c48066&"
import script from "./LoanCardex.vue?vue&type=script&lang=js&"
export * from "./LoanCardex.vue?vue&type=script&lang=js&"
import style0 from "./LoanCardex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports